/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphDto } from '../../models/submissions-graph-dto';

export interface FactorUserPerDayGet$Plain$Params {
  fromDate?: string;
  toDate?: string;
}

export function factorUserPerDayGet$Plain(http: HttpClient, rootUrl: string, params?: FactorUserPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
  const rb = new RequestBuilder(rootUrl, factorUserPerDayGet$Plain.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphDto>>;
    })
  );
}

factorUserPerDayGet$Plain.PATH = '/Factor/user-per-day';
